import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AuthLoginService } from 'src/app/page/auth-page/service/auth-login.service';
import { checklistInterface } from 'src/app/util/interfaces/checklist';
import { environment } from 'src/environments/environment';

@Injectable({
	providedIn: 'root',
})
export class ChecklistExecutionService {
	private getChecklistUrl = environment.baseApiUrl + 'checklist/{idChecklist}';
	private checklistSuccessUrl = environment.baseApiUrl + 'checklist/success/{idChecklist}';
	private checklistFailUrl = environment.baseApiUrl + 'checklist/expire/{idChecklist}';

	private headers = new HttpHeaders({
		Authorization: 'Bearer ' + this.AuthLoginService.getSessionToken(),
		'Content-Type': 'application/json;charset=UTF-8',
	});

	constructor(
		private http: HttpClient,
		private AuthLoginService: AuthLoginService
	) {}

	getChecklistData(idChecklist: string): Observable<checklistInterface> {
		const getChecklistUrl = this.getChecklistUrl.replace('{idChecklist}', idChecklist);
		return this.http.get<checklistInterface>(getChecklistUrl, { headers: this.headers });
	}

	stepSuccess(idChecklist: string): Observable<checklistInterface> {
		const checklistSuccessUrl = this.checklistSuccessUrl.replace('{idChecklist}', idChecklist);
		return this.http.post<checklistInterface>(checklistSuccessUrl, {}, { headers: this.headers });
	}

	stepFail(idChecklist: string): Observable<checklistInterface> {
		const checklistFailUrl = this.checklistFailUrl.replace('{idChecklist}', idChecklist);
		return this.http.post<checklistInterface>(checklistFailUrl, {}, { headers: this.headers });
	}
}
